import {
  getContactsList,
  createContact,
  createContactAgent,
  deleteContact,
  getContactsListCard,
  getContactId,
  getContactContractsById,
  getAgent,
  updateContactAgent,
  updateContact,
  getReportList,
  createReport,
  getReportOne,
  deleteReportPto,
  createReport2
} from '@/api/contacts'

export default {

  FETCH_ALL_REPORT_LIST({ commit }, params) {
    return getReportList(params)
      .then(res => {
        commit('SET_ALL_REPORT_LIST', res.data)
      })
  },

  DELETE_CONTACT_REPORT_PTO({ commit }, id) {
    return deleteReportPto(id)
      .then(res => {
        // commit('SET_ALL_REPORT_LIST', res.data)
        return res.data
      })
  },

  FETCH_ONE_REPORT({ commit }, id) {
    return getReportOne(id)
      .then(res => {
        commit('SET_ONE_REPORT', res.data)
      })
  },
  CREATE_REPORT({ commit }, data) {
    return createReport2(data)
      .then(res => {
        return res.data
      })
  },

  CREATE_REPORT_PTO({ commit }, data) {
    return createReport(data)
      .then(res => {
        return res.data
      })
  },

  FETCH_ALL_CONTACTS_LIST({ commit }, params) {
    return getContactsList(params)
      .then(res => {
        commit('SET_CONTACTS_TABLE_LIST', res.data)
        return res.data
      })
  },
  FETCH_ALL_CONTACTS_LIST2({ commit }, params) {
    return getContactsList(params)
      .then(res => {
        commit('SET_CONTACTS_TABLE_LIST2', res.data)
        return res.data
      })
  },

  FETCH_ALL_CONTACTS_CARD_LIST({ commit }, query) {
    return getContactsListCard(query)
      .then(response => {
        commit('SET_CONTACTS_LIST', response.data)
        return response.data
      })
  },

  FETCH_ALL_CONTACTS_LIST_ID({ commit }, query) {
    return getContactId(query)
      .then(response => {
        commit('SET_ALL_CONTACTS', response.data)
        return response.data
      })
  },
  FETCH_ALL_CONTACTS_CONTRACTS_BY_ID({ commit }, query) {
    return getContactContractsById(query)
      .then(response => {
        commit('SET_ALL_CONTACT_CONTRACTS', response.data)
        return response.data
      })
  },

  UPDATE_CONTRACT_AGENT(_, data) {
    return updateContactAgent(data)
  },

  UPDATE_CONTRACT(_, data) {
    return updateContact(data)
  },

  CREATE_CONTACT(_, data) {
    return createContact(data)
  },

  FETCH_ALL_CONTACTS_AGENT({ commit }, params) {
    return getAgent(params)
      .then(res => {
        commit('SET_CONTACTS_AGENT', res.data)
      })
  },

  CREATE_AGENT(_, data) {
    return createContactAgent(data)
  },

  DELETE_CONTACT(_, id) {
    return deleteContact(id)
  },


}
